import { appLogout, INACTIVITY } from './services/logout';
import { getCurrentUser } from './shared-api-objects/currentUser';

let isIpUser = false; // IP user determined by currentUser.ipAuthenticatedUser
let userActivityTimeout = null;
let userActivityThrottlerTimeout = null;
const INACTIVE_USER_TIME_THRESHOLD = 24 * 60 * 60 * 1000; // 1 day
const INACTIVE_IP_USER_TIME_THRESHOLD = 60 * 30 * 1000; // 30 minutes
const USER_ACTIVITY_THROTTLER_TIME = 60 * 5 * 1000; // 5 minutes

// Activity tracker timeout which will reset every time the userActivityThrottler is called
// whilst active. If the timeout executes the callback, the app will logout accordingly.
// Timeout threshold determine user type.
function resetUserActivityTimeout() {
  clearTimeout(userActivityTimeout);
  userActivityTimeout = setTimeout(
    () => appLogout(INACTIVITY),
    isIpUser ? INACTIVE_IP_USER_TIME_THRESHOLD : INACTIVE_USER_TIME_THRESHOLD
  );
}

// Event Listener callback for user click events.
// The callback will only enable itself every 5 minutes, then start listening
// for click events again. If a user action is detected, it resets the user
// activity timeout. This prevents excessive function calls to the timer.
function userActivityThrottler() {
  if (!userActivityThrottlerTimeout) {
    userActivityThrottlerTimeout = setTimeout(() => {
      resetUserActivityTimeout();
      clearTimeout(userActivityThrottlerTimeout);
      userActivityThrottlerTimeout = null;
    }, USER_ACTIVITY_THROTTLER_TIME);
  }
}

// Get the current user and check if they are an IP Authenticated user to determine
// timeout threshold, then start listening for user click events to begin tracking activity
export function activateActivityTracker() {
  getCurrentUser()
    .then((user) => (isIpUser = user.ipAuthenticatedUser))
    .catch((err) => console.error(err))
    .finally(() => {
      userActivityThrottler();
      window.addEventListener('click', userActivityThrottler);
    });
}

export function deactivateActivityTracker() {
  window.removeEventListener('click', userActivityThrottler);
}
